// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-nav .nav-item p{line-height:inherit;margin-left:5px}", ""]);
// Exports
module.exports = exports;
